import {
    EuiFlexGrid,
    EuiFlexItem,
    EuiFlexGroup,
    EuiTitle,
    EuiHorizontalRule,
    EuiSpacer,
    EuiButton,
} from "@elastic/eui";
import React, { useContext, useMemo, useState } from "react";
import _ from "lodash";
import { EntityProfileContext } from ".";

import ProfileDetailsField from "./ProfileDetailsField";
import AbstractFormContainer from "../AbstractForm/container";
import { singular } from "../../../../../utils/stringUtils";
import { mapResourceObjectToArray } from "../../../../../utils/jsonApiUtils";

function ProfileDetailsBody() {
    const { fields, entityName, entityResource, entity, entityId, fetch } =
        useContext(EntityProfileContext);

    const [createEntityOptions, setCreateEntityOptions] = useState(null);

    const profileDetailsFields = useMemo(
        () =>
            fields.filter(
                (field) => field.type !== "relation" && field.id !== "image" && !field.group
            ),
        [fields]
    );

    const groupFields = useMemo(
        () =>
            _.groupBy(
                fields.filter((field) => field.group),
                "group.id"
            ),
        [fields]
    );
    return (
        <EuiFlexGroup direction="column">
            <EuiFlexItem className="profile-details__section-wrapper">
                <EuiFlexGrid
                    columns={4}
                    gutterSize="l"
                >
                    {profileDetailsFields.map((field) => (
                        <EuiFlexItem key={field.name}>
                            <ProfileDetailsField field={field} />
                        </EuiFlexItem>
                    ))}
                </EuiFlexGrid>
            </EuiFlexItem>

            <EuiFlexItem>
                {!!Object.keys(groupFields).length && <EuiHorizontalRule margin="xs" />}

                {Object.keys(groupFields).map((key) => (
                    <div
                        className="profile-details__section-wrapper"
                        key={key}
                    >
                        {key !== "contract" && (
                            <EuiFlexGroup
                                responsive={false}
                                alignItems="center"
                            >
                                <EuiFlexItem grow={false}>
                                    <EuiTitle size="s">
                                        <h4>{`${groupFields[key][0].group.label} Details`}</h4>
                                    </EuiTitle>
                                </EuiFlexItem>
                                {!entity[groupFields[key][0].group.relationKey] && (
                                    <EuiFlexItem grow={false}>
                                        <EuiButton
                                            style={{ fontWeight: 700, marginLeft: 8 }}
                                            color="primary"
                                            iconType="plus"
                                            onClick={() => {
                                                setCreateEntityOptions(
                                                    groupFields[key][0].group.options
                                                );
                                            }}
                                        >
                                            {`Create a ${groupFields[key][0].group.label}`}
                                        </EuiButton>
                                    </EuiFlexItem>
                                )}
                            </EuiFlexGroup>
                        )}

                        <EuiSpacer size="m" />

                        {!!entity[groupFields[key][0].group.relationKey] && (
                            <EuiFlexGrid
                                columns={4}
                                gutterSize="l"
                            >
                                {groupFields[key].map((field) => (
                                    <EuiFlexItem key={field.name}>
                                        <ProfileDetailsField field={field} />
                                    </EuiFlexItem>
                                ))}
                            </EuiFlexGrid>
                        )}

                        {createEntityOptions && (
                            <AbstractFormContainer
                                entityObject={{
                                    [`${singular(entityName)}Id`]: entityId,
                                    [singular(entityName)]: entity.name,
                                }}
                                includedEntities={{
                                    [singular(entityName)]:
                                        mapResourceObjectToArray(entityResource),
                                }}
                                options={groupFields[key][0].group.options}
                                onFinish={() => {
                                    setCreateEntityOptions(null);
                                    fetch();
                                }}
                                onCancel={() => {
                                    setCreateEntityOptions(null);
                                }}
                                isNested
                            />
                        )}
                    </div>
                ))}
            </EuiFlexItem>
        </EuiFlexGroup>
    );
}

export default ProfileDetailsBody;
